export default "/images/a4063dc0a218dd035033e2991ad98b46.avif";